import { ErrorMessage } from '@hookform/error-message';
import { FormControl, MenuItem, Select, Typography, Grid, InputLabel } from '@material-ui/core';
import React from 'react';
import { Controller } from 'react-hook-form';

export const SelectRhf = ({
    control,
    option,
    name,
    label,
    disable = false,
    errors,
    defaultValue = '',
    style,
    selectStyle = {},
}) => {
    return (
        <>
            {label && label.length > 0 && (
                <Grid item>
                    <Typography
                        // variant='subtitle1'
                        style={{ margin: '6px 0px', color: disable ? 'rgb(177,177,177)' : 'black', fontWeight: 300 }}
                    >
                        {label}
                    </Typography>
                </Grid>
            )}
            <Grid item>
                <FormControl variant="standard" size="small" style={style} disabled={disable} fullWidth>
                    {/* <InputLabel htmlFor='select-component'>{label || ''}</InputLabel> */}
                    <Controller
                        rules={{ required: true }}
                        control={control}
                        name={name}
                        render={({ field: { onChange, value } }) => (
                            <Select
                                fullWidth
                                style={selectStyle}
                                inputProps={{ id: 'select-component' }}
                                id={name}
                                onChange={onChange}
                                value={value}
                                disabled={disable}
                                variant="standard"
                            >
                                {option.map((v, i) => (
                                    <MenuItem key={`${name}-${i}`} value={v}>
                                        {v}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        defaultValue={defaultValue}
                    />
                    <div style={{ marginLeft: 8 }}>
                        <ErrorMessage
                            errors={errors}
                            name={name}
                            render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                        />
                    </div>
                </FormControl>
            </Grid>
        </>
    );
};
